// CookieConsentBanner.js
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  
  useEffect(() => {
    // Check if the consent cookie exists
    const consentCookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('authCookieConsent='));
    
    // If cookie doesn't exist, show the banner
    if (!consentCookie) {
      // Small delay for better UX
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    // Set a cookie that expires in 30 days
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 30);
    
    document.cookie = `authCookieConsent=true; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div 
          className="fixed bottom-0 left-0 right-0 z-50 shadow-lg" 
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ 
            type: "spring", 
            stiffness: 300, 
            damping: 30,
            duration: 0.4
          }}
        >
          <div className="bg-green-dark text-beige-light p-2 md:p-3 flex flex-col md:flex-row justify-between items-center w-full">
            <div className="text-sm md:text-body mb-1 md:mb-0 text-center md:text-left flex-grow">
              <p className="leading-tight">
                Questo sito utilizza cookie essenziali esclusivamente per l'autenticazione. 
                Questi cookie sono necessari per il corretto funzionamento del sito.
              </p>
            </div>
            <button 
              onClick={handleAccept}
              className="button text-sm bg-beige text-green-dark px-4 py-1 md:px-6 md:py-2 rounded-md hover:bg-accent hover:text-beige-light transition-colors whitespace-nowrap flex-shrink-0 ml-2"
            >
              Ho capito
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsentBanner;